import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FiDatePickerModule } from '@fi-shared/fi-date-picker';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { SelectPeriodComponent } from './select-period.component';

@NgModule({
    imports: [CommonModule, FormsModule, FiDatePickerModule, FiAppTextSharedModule],
    declarations: [SelectPeriodComponent],
    exports: [SelectPeriodComponent],
})
export class FiSelectPeriodModule {}
